export interface INavigationMenu {
    id: string;
    paths: string[];
    label: string;
    elementId: string;
    path: string;
    icon?: string;
}

export interface INavigationGroup {
    id: string;
    defaultLabel: string;
    items: INavigationMenu[];
}

export enum NavigationTab {
    SHARED_DOCUMENTS = "shared-documents",
    MANAGER_RESEARCH = "manager-research",
    THOUGHT_LEADERSHIP = "thought-leadership",
    MASTER_LECTURE_SERIES = "master-lecture-series",
    OPERATIONAL_RISK = "operational-risk",
    ODD_REPORTS = "odd-reports",
    REPORTING_HUB = "reporting-hub",
    POWERBI_REPORT_ADMIN = "powerbi-report-admin",
    CPR_SHARED_MEDIA_ADMIN = "cpr-shared-media-admin",
    PORTFOLIO_SNAPSHOT = "portfolio-snapshot",
}

export const ResearchMenu: INavigationMenu = {
    id: NavigationTab.MANAGER_RESEARCH,
    paths: [
        "research",
        "products",
        "strategy-updates",
        "meeting-notes",
        "flash-reports",
        "managers",
        "performance-reporting",
    ],
    label: "Manager Research",
    elementId: "navigation-tab__research",
    path: "/research",
    icon: "fa-regular fa-magnifying-glass",
};

export const PortfolioMenu: INavigationMenu = {
    id: NavigationTab.PORTFOLIO_SNAPSHOT,
    paths: [
        "portfolio",
        "products",
        "strategy-updates",
        "meeting-notes",
        "flash-reports",
        "managers",
    ],
    label: "Portfolio Snapshot",
    elementId: "navigation-tab__portfolio",
    path: "/portfolio",
    icon: "fa-regular fa-chart-pie",
};

export const ThoughtLeadershipMenu: INavigationMenu = {
    id: NavigationTab.THOUGHT_LEADERSHIP,
    paths: ["white-papers", "market-outlooks"],
    label: "Thought Leadership",
    elementId: "navigation-tab__insights",
    path: "/white-papers",
};

export const SharedDocumentsMenu: INavigationMenu = {
    id: NavigationTab.SHARED_DOCUMENTS,
    paths: ["shared-documents"],
    label: "Shared Documents",
    elementId: "navigation-tab__shared-documents",
    path: "/shared-documents",
};

export const MasterLectureSeriesMenu: INavigationMenu = {
    id: NavigationTab.MASTER_LECTURE_SERIES,
    paths: ["master-lecture-series"],
    label: "Master Lecture Series",
    elementId: "navigation-tab__master-lecture-series",
    path: "/master-lecture-series",
};

export const OddPortfolioMenu: INavigationMenu = {
    id: NavigationTab.OPERATIONAL_RISK,
    paths: [
        "odd-iq",
        "odd",
    ],
    label: "Operational Risk",
    elementId: "navigation-tab__odd-iq",
    path: "/odd-iq",
    icon: "fa-regular fa-shield",
};

export const OddReportsMenu: INavigationMenu = {
    id: NavigationTab.ODD_REPORTS,
    paths: ["odd-reports"],
    label: "Operational Due Diligence Reports",
    elementId: "navigation-tab__odd-reports",
    path: "/odd-reports",
    icon: "fa-regular fa-clipboard-list",
};

export const ClientReportingMenu: INavigationMenu = {
    id: NavigationTab.REPORTING_HUB,
    paths: ["client-reporting"],
    label: "Reporting Hub",
    elementId: "navigation-tab__client-reporting",
    path: "/client-reporting",
    icon: "fa-regular fa-file-lines",
};

export const PowerbiReportAdminMenu: INavigationMenu = {
    id: NavigationTab.POWERBI_REPORT_ADMIN,
    paths: ["powerbi-report-admin"],
    label: "PowerBI Report Admin",
    elementId: "navigation-tab__powerbi-report-admin",
    path: "/powerbi-report-admin",
};

export const CprSharedMediaAdminMenu: INavigationMenu = {
    id: NavigationTab.CPR_SHARED_MEDIA_ADMIN,
    paths: ["cpr-shared-media-admin"],
    label: "CPR Shared Media Files",
    elementId: "navigation-tab__cpr-shared-media-admin",
    path: "/cpr-shared-media-admin",
};

export const AllNavigationMenus: INavigationMenu[] = [
    PortfolioMenu,
    ResearchMenu,
    ClientReportingMenu,
    OddPortfolioMenu,
    SharedDocumentsMenu,
    ThoughtLeadershipMenu,
    // MasterLectureSeriesMenu,
    OddReportsMenu,
    PowerbiReportAdminMenu,
    CprSharedMediaAdminMenu
];

export const PortfolioInsightsGroup: INavigationGroup = {
    id: "portfolio-insights",
    defaultLabel: "Portfolio Insights",
    items: [PortfolioMenu, ClientReportingMenu, OddPortfolioMenu],
};

export const ManagerStudioGroup: INavigationGroup = {
    id: "manager-studio",
    defaultLabel: "Manager Studio",
    items: [ResearchMenu, OddReportsMenu],
};

export const NavigationGroups: INavigationGroup[] = [
    PortfolioInsightsGroup,
    ManagerStudioGroup,
];

export const UserBehaviorTrackerPathsToIgnore: string[] = [
    "/",
    "/portfolio"
];
